import { z } from "zod";

export const qlikDimensionSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().optional(),
  fieldDefs: z.array(z.string()),
  fieldLabels: z.array(z.string()),
  grouping: z.string().optional(),
  tags: z.array(z.string()),
  labelExpression: z.string().optional(),
});

export type QlikDimension = z.infer<typeof qlikDimensionSchema>;

export const listQlikDimensionsResponseSchema = z.object({
  data: z.array(qlikDimensionSchema),
});

export type ListQlikDimensionsResponse = z.infer<typeof listQlikDimensionsResponseSchema>;

export const updateQlikDimensionInputSchema = z.object({
  title: z.string().min(1).optional(),
  description: z.string().optional(),
  fieldDefs: z.array(z.string()).optional(),
  fieldLabels: z.array(z.string()).optional(),
  grouping: z.enum(["N", "H", "C"]).optional(),
  tags: z.array(z.string()).optional(),
  labelExpression: z.string().optional(),
});

export type UpdateQlikDimensionInput = z.infer<typeof updateQlikDimensionInputSchema>;
